import { useState, useEffect } from "react";

function useWindowSize() {
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
  const [breakpoints, setBreakpoints] = useState({
    isSm: window.innerWidth >= 640,
    isMd: window.innerWidth >= 768,
    is2Md: window.innerWidth >= 840,
    isLg: window.innerWidth >= 1024,
    isXl: window.innerWidth >= 1200,
    isXxl: window.innerWidth >= 1440,
  });

  useEffect(() => {
    function handleResize() {
      const width = window.innerWidth;
      const height = window.innerHeight;

      setWindowHeight(height);
      setWindowWidth(width);
      
      setBreakpoints({
        isSm: width >= 640,
        isMd: width >= 768,
        is2Md: width >= 840,
        isLg: width >= 1024,
        isXl: width >= 1200,
        isXxl: width >= 1440,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);

  }, []); 

  return { windowHeight, windowWidth, ...breakpoints };
}

export default useWindowSize;